import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

const COLOR = {
  normal: styles.colorNormal,
  error: styles.colorError,
};

type Props = {
  className?: string;
  style?: React.CSSProperties;
  label?: React.ReactNode;
  content?: React.ReactNode;
  children?: React.ReactNode;
  isValueEmpty: boolean;
  color?: keyof typeof COLOR;
  controlDescendantPlaceholder: boolean;
  disabled?: boolean;
  alwaysShrinkLabel?: boolean;
  hideLabel?: boolean;
};

// NOTE: Don't nest FormControlShell inside another FormControlShell
export default function FormControlShell({
  className,
  style,
  label,
  content,
  children = content,
  isValueEmpty,
  color = "normal",
  controlDescendantPlaceholder,
  disabled,
  alwaysShrinkLabel,
  hideLabel,
}: Props) {
  return (
    <div
      className={cx(
        styles.container,
        className,
        COLOR[color],
        disabled ? styles.disabled : null,
        controlDescendantPlaceholder
          ? styles.controlDescendantPlaceholder
          : null,
        alwaysShrinkLabel ? styles.alwaysShrinkLabel : null,
        hideLabel || !label ? styles.hideLabel : null
      )}
      style={style}
      {...(isValueEmpty ? { "data-empty": true } : undefined)}
    >
      {children}
      <label className={styles.labelShrink}>{label}</label>
      <label className={styles.labelExpand}>{label}</label>
      <fieldset className={styles.fieldset} aria-hidden>
        <legend className={styles.legend}>
          <div className={styles.legendContent}>{label}</div>
        </legend>
      </fieldset>
    </div>
  );
}
